export default "__VITE_ASSET__CJZBAr_Z__"